import { defineStore } from 'pinia'
import { ref } from 'vue'

// 人员选择状态管理
export const usePersonSelectStore = defineStore('personSelect', () => {
  // 存储每个实例的ID和对应的选择结果
  const instances = ref(new Map())
  // 当前活动的实例ID（用于解决多实例同时监听消息的问题）
  const activeInstanceId = ref('')

  /**
   * 设置实例数据
   * @param {string} instanceId 实例ID
   * @param {Object} data 数据对象
   */
  const setInstanceData = (instanceId, data) => {
    instances.value.set(instanceId, data)
  }

  /**
   * 获取实例数据
   * @param {string} instanceId 实例ID
   * @returns {Object} 实例数据
   */
  const getInstanceData = (instanceId) => {
    return instances.value.get(instanceId) || null
  }

  /**
   * 删除实例数据
   * @param {string} instanceId 实例ID
   */
  const removeInstanceData = (instanceId) => {
    instances.value.delete(instanceId)
  }

  /**
   * 获取所有实例
   * @returns {Map} 实例Map
   */
  const getAllInstances = () => {
    return instances.value
  }

  /**
   * 设置当前活动的实例ID
   * @param {string} instanceId 实例ID
   */
  const setActiveInstance = (instanceId) => {
    activeInstanceId.value = instanceId
  }

  /**
   * 获取当前活动的实例ID
   * @returns {string} 当前活动的实例ID
   */
  const getActiveInstance = () => {
    return activeInstanceId.value
  }

  /**
   * 清除当前活动的实例ID
   */
  const clearActiveInstance = () => {
    activeInstanceId.value = ''
  }

  return {
    instances,
    activeInstanceId,
    setInstanceData,
    getInstanceData,
    removeInstanceData,
    getAllInstances,
    setActiveInstance,
    getActiveInstance,
    clearActiveInstance
  }
})
